"use client";

import { useTriggerAction, type BlokAction } from "@/lib/action-link";

const CLASS =
  "hidden h-14 items-center justify-center rounded-[8px] bg-purple-03 px-7 text-body font-bold text-white transition-colors hover:bg-purple-04 lg:inline-flex";

export default function ExplainerButton({
  label,
  href,
  target,
  action,
}: {
  label: string;
  href: string;
  target?: string;
  action?: BlokAction | "";
}) {
  const triggerAction = useTriggerAction();

  if (action) {
    return (
      <button
        type="button"
        onClick={(e) => triggerAction(action, e)}
        className={`cursor-pointer ${CLASS}`}
      >
        {label}
      </button>
    );
  }

  return (
    <a
      href={href}
      {...(target ? { target } : {})}
      className={CLASS}
    >
      {label}
    </a>
  );
}
